import Offline from '@/common/swagger/offline/offline';

export default {
  ...Offline
};
